import DOMPurify from 'dompurify';

/**
 * Hafif markdown -> HTML dönüştürücü.
 * Yorumlar, görev açıklamaları, revizyon nedeni ve inceleme notlarında
 * aynı stil/parametreleri sağlamak için tek noktadan kullanılır.
 *
 * Destekler:
 *  - **kalın**
 *  - *italik*
 *  - ## Başlık
 *  - - Madde listesi  (veya • madde)
 *  - URL'leri linkleştirir
 *
 * Çıktı: { __html: '...' } — React `dangerouslySetInnerHTML` ile uyumlu.
 */
export const formatRichText = (text) => {
  if (!text) return { __html: '' };

  // HTML escape (XSS güvenliği için DOMPurify de var ama yine de önden escape)
  let safe = String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\r/g, '');

  // Satır bazlı: başlık + madde listesi
  const lines = safe.split('\n').map((line) => {
    if (/^##\s*(.+)$/.test(line)) {
      return line.replace(/^##\s*(.+)$/, '<strong class="text-base font-bold block mt-1">$1</strong>');
    }
    if (/^[-•]\s*(.+)$/.test(line)) {
      // Inline bullet (line-clamp ve <br> birleştirmesiyle uyumlu)
      return line.replace(/^[-•]\s*(.+)$/, '• $1');
    }
    return line;
  });
  safe = lines.join('<br>');

  // URL linkleştirme
  safe = safe.replace(
    /(https?:\/\/[^\s<]+)/g,
    '<a href="$1" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:text-blue-800 underline break-all">$1</a>'
  );

  // Inline formatting
  safe = safe.replace(/\*\*(.*?)\*\*/g, '<strong class="font-semibold">$1</strong>');
  safe = safe.replace(/(?<!\*)\*([^*]+)\*(?!\*)/g, '<em class="italic">$1</em>');

  const clean = DOMPurify.sanitize(safe, {
    ALLOWED_TAGS: ['br', 'a', 'strong', 'em', 'span'],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class'],
  });

  return { __html: clean };
};
